/**
 * Validates that given date value is equal or greater than given minAge
 *
 * @param {string} value  - Date in format 'dd.mm.yyyy'
 * @param {number} minAge - Minimum age in years
 *
 * @return {boolean}
 */
const minAge = (value, minAge) => {
  const MIN_AGE = Number(minAge);
  const dateParts = value.split('.');
  const date = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const ageMonths = today.getMonth() - date.getMonth();

  if(ageMonths < 0 || (ageMonths === 0 && today.getDate() < date.getDate())) {
    age--;
  }

  return age >= MIN_AGE;
};

/**
 * Validates that given number is equal or greated than minValue
 *
 * @param {string} value - Numeric string
 * @param {*} minValue - Minimum value
 *
 * @return {boolean}
 */
const minValue = (value, minValue) => {
  const MIN_VALUE = Number(minValue);
  // check fo commas and replace with decimal
  const parsedValue = parseFloat(value.replace(',', '.'));

  return parsedValue >= MIN_VALUE;
};

/**
 * Validates that selected option amount is equal or less than maxAmount
 *
 * @param {string} value - Numeric string
 * @param {*} maxAmount - Minimum value
 *
 * @return {boolean}
 */
const maxAmount = (value, maxAmount) => {
  const MAX_AMOUNT = Number(maxAmount);
  return value <= MAX_AMOUNT;
};

export {
  minAge,
  minValue,
  maxAmount
};
